import { gsap } from "./gsapSetup";

function splitToChars(el) {
  const text = el.textContent;
  el.textContent = "";

  const frag = document.createDocumentFragment();

  Array.from(text).forEach((ch) => {
    if (ch === " ") {
      frag.appendChild(document.createTextNode("\u00A0"));
      return;
    }
    const span = document.createElement("span");
    span.className = "char";
    span.textContent = ch;
    frag.appendChild(span);
  });

  el.appendChild(frag);
  return el.querySelectorAll(".char");
}

export function initTitleLetters() {
  const title = document.querySelector(".gs-title2");
  if (!title) return;

  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const words = Array.from(title.querySelectorAll("span"));
  if (!words.length) return;

  const wordChars = words.map(splitToChars);

  if (prefersReduced) {
    wordChars.flat().forEach((c) => {
      c.style.opacity = "1";
      c.style.transform = "none";
      c.style.filter = "none";
    });
    return;
  }

  const tl = gsap.timeline({
    defaults: {
      ease: "power3.out", // smoother base curve
    },
  });

  wordChars.forEach((chars, i) => {
    // main reveal
    tl.to(
      chars,
      {
        opacity: 1,
        y: "0em",
        filter: "blur(0px)",
        duration: 0.65,
        stagger: {
          each: 0.025,
          ease: "power2.out", // 👈 smooth stagger ease
        },
      },
      i === 0 ? 0 : ">-=0.2"
    );

    // micro settle (very subtle)
    tl.fromTo(
      chars,
      { y: "-0.06em" },
      {
        y: "0em",
        duration: 0.35,
        ease: "expo.out", // 👈 soft settle
        stagger: 0.02,
      },
      ">-=0.45"
    );
  });
}
